/**
 * @generated SignedSource<<7949ab1c04ac9b91c616478050cbe3f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tick",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Recurring",
    "kind": "LinkedField",
    "name": "pauseRecurring",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Recurringtick",
        "kind": "LinkedField",
        "name": "recurringtick",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cancelRecurringPauseMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cancelRecurringPauseMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "21b3672a0ae2796e87facf7e1056c606",
    "id": null,
    "metadata": {},
    "name": "cancelRecurringPauseMutation",
    "operationKind": "mutation",
    "text": "mutation cancelRecurringPauseMutation(\n  $request: RecurringPauseRequestInput\n) {\n  pauseRecurring(request: $request) {\n    id\n    recurringtick {\n      id\n      status\n      tick\n    }\n    tick\n  }\n}\n"
  }
};
})();

node.hash = "931a6cafa80f558606884abcf5b108c1";

module.exports = node;
